import Vue from 'vue'
import './plugins/axios'
import './plugins/useApi'
import App from './App.vue'
import router from './router'
import store from './store/index.js'
import './plugins/element.js'
import 'normalize.css'
import '@/styles/index.scss' // global css
import tracer from '@/utils/tracer'
import '@/utils/tracer/directive'
import '@/api'

import waterMark from '@/utils/water-mark'
import '@/directive/clickoutside'
import '@/directive/high-light'
import '@/decorators/tracer'
import '@/decorators/confirmation'
import VueMatomo from 'vue-matomo'

import * as filters from './filters' // global filters
Vue.config.productionTip = false
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

router.beforeEach(async (to, from, next) => {

  if (store.getters.userInfo.id) {
    next()
  } else {
    store.dispatch('getInfo').then(res => {
      //调用水印
      waterMark.set(store.getters.userInfo.name + "-" + store.getters.userInfo.uid);
      //调用埋点
      if (tracer.useTrack) {
        tracer.baseParam.uid = store.getters.userInfo.uid
        tracer.create()
      }
      bossMatomo()
      next()
    })

  }
  if (store.getters.status) {
    next()
  } else {
    await store.dispatch('getSystem')
    next()
  }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

function bossMatomo () {
  // 实现test、stage、online的识别
  var onlinePattern = new RegExp("http[s]{0,1}://[a-zA-Z0-9]+.yunshanmeicai.com")
  var stagePattern = new RegExp("http[s]{0,1}://[a-zA-Z0-9]+.stage.yunshanmeicai.com")
  var testPattern = new RegExp("http[s]{0,1}://[a-zA-Z0-9]+.test.yunshanmeicai.com")
  var matomoUrl = ''
  var matomoSiteId = 0
  if(onlinePattern.test(window.location.href)) {
    matomoUrl = "https://boss-matomo.yunshanmeicai.com"
    matomoSiteId = 16// 配置分配的线上环境的SiteId
  }
  if(stagePattern.test(window.location.href)) {
    matomoUrl = "https://boss_matomo.stage.yunshanmeicai.com";
    matomoSiteId =16//配置分配的stage环境的SiteId
  }
  if(testPattern.test(window.location.href)) {
    matomoUrl = "https://boss-matomo.test.yunshanmeicai.com";
    matomoSiteId = 2//配置分配的test环境的SiteId
  }
  Vue.use(VueMatomo, {
    host: matomoUrl,
    siteId: matomoSiteId,
    trackerFileName: 'matomo',
    router: router,
    enableLinkTracking: true,
    requireConsent: false,
    trackInitialView: true,
    disableCookies: false,
    enableHeartBeatTimer: false,
    heartBeatTimerInterval: 15,
    debug: false,
    userId: store.getters.userInfo.cas_info.usernmae,
    cookieDomain: undefined,
    domains: undefined,
    preInitActions: []
  })
}
